<template>
  <div class="layout">
    <img
      class="iconLogo"
      src="~@/assets/imgs/login/xkool_logo_white.svg"
      alt=""
    />
    <div class="content">
      <password-login-form
        :goTo="goTo"
        :setWechatUnionId="setWechatUnionId"
        v-if="formType === 0"
      />
      <registe-form :goTo="goTo" v-if="formType === 1" />
      <wechat-bind-form :goTo="goTo" v-if="formType === 2" />
    </div>
    <language-button />
  </div>
</template>

<script>
/** 登录注册页容器 */
import PasswordLoginForm from "./components/PasswordLoginForm";
import RegisteForm from "./components/RegisteForm";
import WechatBindForm from "./components/WechatBindForm";
import { FormType } from "@/models/user";
import LanguageButton from "@/components/LanguageButton";

export default {
  name: "login",
  components: {
    PasswordLoginForm,
    RegisteForm,
    LanguageButton,
    WechatBindForm,
  },
  data() {
    return {
      formType: FormType.PASSWORD_LOGIN,
      wechatBindUnionId: undefined,
    };
  },
  methods: {
    goTo(formType) {
      this.formType = formType;
    },
    setWechatUnionId(id) {
      this.wechatBindUnionId = id;
    },
  },
};
</script>

<style lang="less" scoped>
.layout {
  width: 100vw;
  height: 100vh;
  padding-top: 130px;
  overflow-y: auto;
  background-image: url("~@/assets/imgs/login/login_bg.svg");
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
}
.iconLogo {
  position: absolute;
  top: 0;
  left: 50%;
  color: white;
  transform: translateX(-50%);
  width: 100px;
  height: 100px;
}
.content {
  display: flex;
  max-width: 90vw;
  width: 375px;
  margin: auto;
  padding: 30px;
  overflow: hidden;
  background: white;
  border-radius: 20px;
}
</style>
